export default "__VITE_ASSET__DSv1Zc9K__"